module.exports = __webpack_public_path__ + "img/product-preview-59.64b1856.png";